import {validateInput} from '@/drc/services/validation.service';
import {
	fetchAllCompetitors, fetchAllEditors,
	fetchAllGlobalOwners,
	fetchAllIndustries, fetchAllLifecycles, fetchAllMainClientPersonas,
	fetchAllServiceLines,
	fetchAllTechPractices, fetchCountries, fetchProjects, getAllOffers, getAllSectors, getGlobalOffers
} from "@/common/services/common-graphql-service";
import * as COMMON_GRAPHQL_SERVICE from "@/common/services/common-graphql-service"
import {ANNUAL_REVENUES, ATTRIBUTE_STATUS, ATTRIBUTE_TYPE, OFFER_TYPES_ENUM, MATURITIES} from "@/common/utils/constants";
import {getRecognitionsDropdownList} from "@/gop/services/recognition.service";

export {validateInput};

export let baseOffer = {
	language: [],
	type: [],
	globalOffer: [],
	title: '',
	thumbnail: null,
	panoramicPhoto: null,
	mobilePanoramicPhoto: null,
	description: '',
	deliveryLocation: [],
	// ftes: {},
	presentationPPT: null,
	presentationPDF: null,
	videoLinks: [{videoLinkName: '', videoLinkUrl: ''}],
	globalOwners: [{fullName: '', email: ''}],
	mainGlobalOwner: [],
	projectIndustry: null,
	serviceLines: [],
	techPractices: [],
	mainClientPersona: [],
	lifecycle: [],
	toolsAndSystems: [],
	certifications: [],
	largestMarket: [],
	fastestGrowingMarket: [],
	biggestMarketConclusion: '',
	keyMarketDrivers: '',
	marketOpportunities: '',
	keyHighlights: '',
	additionalNotes: '',
	competitors: [],
	clientNeeds: '',
	clientBenefits: '',
	tips: '',
	links: [{linkName: '', linkUrl: ''}],
	reference: [{id: '', referenceTitle: '', firstDatePublished: ''}],
	relatedOffersEn: [],
	relatedOffersDe: [],
	relatedOffersFr: [],
	relatedOffersIt: [],
	relatedOffersJa: [],
	relatedOffersEs: [],
	mainTechPractice:[],
	resources: [{name: '', currName: ''}],
	recognitions: [],
	relatedSectors: [],
	editors: [{editorFullName: '', editorEmail: ''}],
	annualRevenue: [],
	maturity: []
}

export let originalTranslations = {};

export let offer = JSON.parse(JSON.stringify(baseOffer));

export function resetOffer() {
	offer = JSON.parse(JSON.stringify(baseOffer));
	originalTranslations = {};
}

export function getEmptyFieldsNames(offer) {
	const emptyFields = [];
	for (const field of Object.keys(offer)) {
		if(field === 'globalOffer') {
			if (offer.type[0].name === OFFER_TYPES_ENUM.LOCALIZED && offer[field].length === 0) {
				emptyFields.push(field)
			}
		}else if (field.indexOf('relatedOffer') !== -1) {
			continue;
		}else	if (typeof offer[field] === "string" && offer[field].length === 0) {
			emptyFields.push(field)
		} else if (Array.isArray(offer[field])) {
			if(field === 'reference'){
				const references = offer[field].filter(el => el.referenceTitle.length !== 0 || el.firstDatePublished.length !== 0)
				if(references.length === 0){
					emptyFields.push('referencesAndSuccessStories')
				}
			}else{
				if(offer[field].length === 0){
					emptyFields.push(field)
				}
			}
		}
	}
	return emptyFields;
}

export function getDropdownData(currentId) {
	const promises = [
		fetchAllGlobalOwners().then((response) => {
			this.globalOwners = response;
		}),
		fetchAllEditors().then((response) => {
			this.editors = response.map(el => {return {editorFullName: el.fullName, editorEmail: el.email, id: el.id}});
		}),
		fetchAllIndustries().then((response) => {
			this.industries = response;
		}),
		fetchAllServiceLines().then((response) => {
			this.serviceLines = response;
		}),
		fetchAllTechPractices().then((response) => {
			this.techPractices = response;
		}),
		fetchAllMainClientPersonas().then((response) => {
			this.mainClientPersonas = response;
		}),
		fetchAllLifecycles().then((response) => {
			this.lifecycles = response;
		}),
		COMMON_GRAPHQL_SERVICE.fetchGopQualificationAttributes(ATTRIBUTE_TYPE.tool, [ATTRIBUTE_STATUS.APPROVED])
			.then((response) => {
				this.toolsAndSystems = response;
			}),
		COMMON_GRAPHQL_SERVICE.fetchGopQualificationAttributes(ATTRIBUTE_TYPE.certification, [ATTRIBUTE_STATUS.APPROVED])
			.then((response) => {
				this.certifications = response;
			}),
		fetchAllCompetitors().then((response) => {
			this.competitors = response;
		}),
		fetchCountries().then((response) => {
			this.countries = response;
		}),
		fetchProjects().then((response) => {
			this.projects = response;
		}),
		getGlobalOffers().then((response) => {
			this.globalOffers = response
				.filter(offer => offer.isActive && offer.isPublished && offer.translations?.[0]?.languageId === 1)
				.sort((a, b) => a.translations?.[0]?.title.localeCompare(b.translations?.[0]?.title))
				.map(el => {
					const localizedOfferCountries = [];
					const localizedOfferIds = [];
					el.localizedOffers.forEach(localizedOffer => {
						if(currentId && localizedOffer.id == currentId){
							return;
						}

						localizedOffer.countryRelations.filter(country => country.type === "DELIVERY_LOCATION").forEach(country => {
							if(!localizedOfferCountries.includes(country.countryId)){
								localizedOfferCountries.push(country.countryId)
								localizedOfferIds.push(localizedOffer.id)
							}
						});
					});
					return {
						id: el.id,
						name: el.translations?.[0]?.title,
						localizedOfferDeliveryCountries: localizedOfferCountries,
						localizedOfferIds: localizedOfferIds
					}
				})
		}),
		getAllOffers().then((response) => {
			this.offers = response
		}),
		getRecognitionsDropdownList().then((response) => {
			this.recognitions = response
		}),
		getAllSectors().then((response) => {
			this.sectors = response
		})
	]
	return Promise.all(promises);
}

export const industries = [];
export const serviceLines = [];
export const techPractices = [];
export const mainClientPersonas = [];
export const lifecycles = [];
export const toolsAndSystems = [];
export const certifications = [];
export const globalOwners = [];
export const competitors = [];
export const countries = [];
export const projects = [];
export const globalOffers = [];
export const offers = [];
export const recognitions = [];
export const sectors = [];

export let originalFiles = [];
export let originalLinks = [];
export let editors = [];
export let annualRevenues = ANNUAL_REVENUES;
export let maturities = MATURITIES

export let refs = {
	language: null,
	type: null,
	globalOffer: null,
	title: null,
	description: null,
	thumbnail: null,
	panoramicPhoto: null,
	mobilePanoramicPhoto: null,
	deliveryLocation: null,
	// ftes: null,
	presentationPPT: null,
	presentationPDF: null,
	globalOwners: null,
	mainGlobalOwner: null,
	fullName0: null,
	email0: null,
	projectIndustry: null,
	videoLinks: null,
	videoLinkName0: null,
	videoLinkUrl0: null,
	serviceLines: null,
	techPractices: null,
	largestMarket: null,
	fastestGrowingMarket: null,
	biggestMarketConclusion: null,
	keyMarketDrivers: null,
	marketOpportunities: null,
	clientBenefits: null,
	clientNeeds: null,
	tips: null,
	mainClientPersona: null,
	lifecycle: null,
	toolsAndSystems: null,
	certifications: null,
	keyHighlights: null,
	additionalNotes: null,
	competitors: null,
	links: null,
	linkUrl0: null,
	linkName0: null,
	reference: null,
	referenceDescription0: null,
	referenceUrl0: null,
	mainTechPractice: null,
	relatedOffersEn: null,
	relatedOffersDe: null,
	relatedOffersFr: null,
	relatedOffersIt: null,
	relatedOffersJa: null,
	relatedOffersEs: null,
	resources: null,
	recognitions: null,
	relatedSectors: null,
	editors: null,
	editorFullName0: null,
	editorEmail0: null,
	annualRevenue: null,
	maturity: null
}

export const validations = {
	language: {order: 0, min: 1},
	type: {order: 5, min: 1},
	globalOffer: {order: 7, min: 1},
	title: {order: 10, required: true, min: 1, max: 100},
	thumbnail: {order: 20, required: true, maxHeight: 200, maxWidth: 300, allowedFormats: ['image/jpeg', "image/png"]},
	panoramicPhoto: {
		order: 30,
		required: true,
		allowedFormats: ['image/jpeg', "image/png"]
	},
	mobilePanoramicPhoto: {
		order: 40,
		required: true,
		allowedFormats: ['image/jpeg', "image/png"]
	},
	description: {order: 50, required: true, min: 1, max: 10000},
	deliveryLocation: {order: 60, min: 1},
	relatedOffersEn: {order: 63},
	relatedOffersDe: {order: 64},
	relatedOffersFr: {order: 65},
	relatedOffersIt: {order: 66},
	relatedOffersJa: {order: 67},
	relatedOffersEs: {order: 68},
	editorFullName: {order: 69, min: 1, max: 100},
	editorEmail: {order: 70, min: 1, max: 100, checkEmail: true},
	editors: {order: 71, isUnique: true},
	// ftes: {order: 6, required: true},
	presentationPPT: {
		order: 75,
		required: true,
		allowedFormats: ['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation']
	},
	presentationPDF: {order: 80, required: true, allowedFormats: ['application/pdf']},
	videoLinks: {order: 90},
	videoLinkName: {order: 91, min: 3, max: 255},
	videoLinkUrl: {order: 92, min: 3, max: 255, checkUrl: true},
	globalOwners: {order: 100, required: true, isUnique: true},
	mainGlobalOwner: {order: 460, required: true, min: 1},
	fullName: {order: 110, min: 1, max: 100, required: true},
	email: {order: 120, min: 1, max: 100, checkEmail: true, required: true},
	projectIndustry: {order: 130, groupMin: 1},
	serviceLines: {order: 140, groupMin: 1},
	mainTechPractice: {order: 150, min: 1},
	techPractices: {order: 160, groupMin: 1},
	mainClientPersona: {order: 170},
	lifecycle: {order: 180},
	toolsAndSystems: {order: 190},
	certifications: {order: 200},
	annualRevenue: {order: 205},
	maturity: {order: 208},
	largestMarket: {order: 210},
	fastestGrowingMarket: {order: 220},
	biggestMarketConclusion: {order: 230, min: 1, max: 10000},
	keyMarketDrivers: {order: 240, min: 1, max: 10000},
	marketOpportunities: {order: 250, min: 1, max: 10000},
	keyHighlights: {order: 260, min: 1, max: 10000},
	additionalNotes: {order: 270, min: 1, max: 10000},
	competitors: {order: 280},
	clientNeeds: {order: 290, min: 1, max: 10000},
	clientBenefits: {order: 300, min: 1, max: 10000},
	tips: {order: 310, min: 1, max: 10000},
	reference: {order: 320, required: true, isUnique: true},
	referenceDescription: {order: 330, min: 3, max: 255},
	referenceUrl: {order: 340, min: 3, max: 800, checkUrl: true},
	referenceTitle: {order: 350, min: 1, max: 255},
	resources: {
		order: 360,
		nameMaxLength:255,
		allowedFormats: ['application/pdf', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'image/jpeg', "image/png", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/vnd.oasis.opendocument.text"]
	},
	logo: {order: 360, nameMaxLength:255, allowedFormats: ['image/jpeg', "image/png"]},
	links: {order: 370},
	linkName: {order: 380, min: 1, max: 255},
	linkUrl: {order: 390, min: 3, max: 800, checkUrl: true},
	recognitions: {order: 400},
	relatedSectors: {order: 410},
	url: {order: 450, checkUrl: true},
}

export function validateFile(field, data, type) {
	let errors = [];

	if(typeof data[field] === "string") {
		return errors;
	}

	if (!this.validations[field].required) {
		return errors;
	} else if (!data[field]) {
		errors.push('notEmpty')
		return errors;
	}

	if (!type || (this.validations[field].allowedFormats && this.validations[field].allowedFormats.indexOf(type) === -1)) {
		errors.push('fileType')
	}
	return errors;
}

export function validateSingularSelectGroup(data, field) {
	let errors = [];

	if (this.validations[field]?.isUnique) {
		let uniqueItems = [];
		data[field].forEach((item) => {
			const isEmptyObject = Object.values(item).every(x => (x === null || x === ''));
			if (isEmptyObject) {
				return;
			}

			const stringifiedItem = JSON.stringify(item, Object.keys(item).sort());
			if (uniqueItems.indexOf(stringifiedItem) === -1) {
				uniqueItems.push(stringifiedItem)
			} else {
				if(errors.indexOf('notUnique') === -1) {
					errors.push('notUnique');
				}
			}
		});
	}

	return errors;
}

export function validateImage(height, width, type, field, data) {
	let errors = [];

	if (!this.validations[field].required) {
		return errors;
	} else if (!data[field]) {
		errors.push('notEmpty')
		return errors;
	}

	if(field === 'panoramicPhoto') {
		if(!((height === 535 && width === 1920) || (height === 338 && width === 1200))) {
			errors.push('dimensions')
		}
	}else if(field === 'mobilePanoramicPhoto') {
		if(!((height === 400 && width === 480) || (height === 400 && width === 460))) {
			errors.push('mobileDimensions')
		}
	}else{
		if (this.validations[field].maxHeight && height < this.validations[field].maxHeight) {
			errors.push('notValidHeight')
		}

		if (this.validations[field].maxWidth && width < this.validations[field].maxWidth) {
			errors.push('notValidWidth')
		}
	}

	if(typeof data[field] === "string") {
		return errors;
	}else{
		if (!type || (this.validations[field].allowedFormats && this.validations[field].allowedFormats.indexOf(type) === -1)) {
			errors.push('imageType')
		}
	}
	return errors;
}

export function validateDropdown(field) {
	let errors = [];

	if(field === "globalOffer"){
		if(this.offer?.type?.[0]?.id === 2){
			if(this.offer[field]?.length === 0){
				errors.push({name: 'notEmpty'})
			}
		}
	}else{
		if (this.validations[field].min && (!this.offer[field] || this.offer[field]?.length < this.validations[field].min)) {
			errors.push({name: 'notEnoughSelected', min: this.validations[field].min})
		}
		if (this.validations[field].max && this.offer[field]?.length > this.validations[field].max) {
			errors.push({name: 'tooManySelected', max: this.validations[field].max})
		}
	}
	return errors;
}

export function validateMultipleDropdown(field) {
	let errors = [];

	if (!this.offer[field] || (this.validations[field].groupMin && this.offer[field].length < this.validations[field].groupMin)) {
		errors.push({name: 'notEnoughSelected', min: this.validations[field].groupMin})
	}
	if (this.validations[field].groupMax && this.offer[field]?.length > this.validations[field].groupMax) {
		errors.push({name: 'tooManySelected', max: this.validations[field].groupMax})
	}

	return errors;
}

export function validateRadio(field) {
	let errors = [];

	if (this.validations[field].required && Object.keys(this.offer[field]).length === 0) {
		errors.push({name: 'notEmpty'})
	}

	return errors;
}

export function validateForm() {
	const errors = {};
	for (const field of Object.keys(validations)) {
		errors[field] = validateInput(offer[field], validations[field]);
	}
	return errors
}
